<template>
  <v-dialog persistent v-if="dialog" v-model="dialog" max-width="500px">
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>
          Merge Existing Data Source
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pb-0">
        <p>
          Merge a data source into this location. The selected data source's aliases and their data will be moved to
          this location.
        </p>
        <p>
          <strong>Note:</strong> Data sources with non-primary aliases cannot be merged. Please separate the
          non-primary aliases and merge them individually.
        </p>
        <p class="mb-0">
          Merge existing data sources as
          <strong>Alias Type:</strong>
        </p>
        <v-radio-group class="mt-1 pb-0" v-model="mergeType" hide-details>
          <v-radio v-for="(type, index) in ALIAS_TYPES" color="primary" :key="`mergeType-${index}`" :label="type.text" :value="type.value" />
        </v-radio-group>
      </v-card-text>
      <MergeAliasForm ref="form" :givenStation="currentDiscreteStation" :isQaQc="isQaQc" :isDepthHeightDatum="isDepthHeightDatum" @close="close()" :valid.sync="formIsValid" />
      <v-card-actions>
        <v-spacer />
        <v-btn color="success" :loading="loading" @click="submit()" :disabled="!formIsValid">
          <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn outline color="secondary" @click="close()" :disabled="loading">
          {{ $t('Button.Cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import MergeAliasForm from './MergeAliasForm'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')

  import {
    ALIAS_TYPES,
  } from '@/helpers/synonyms'

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    components: {
      MergeAliasForm,
    },
    data() {
      return {
        ALIAS_TYPES,
        mergeType: ALIAS_TYPES.alias.value,
        dialog: false,
        targetStation: null,
        loading: false,
        formIsValid: true,
      }
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceIndexByType']),
      ...dataSources.mapGetters(['dataSourceIndex']),
      discreteDataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.discreteEnvirodata]
      },
      discreteStationsIndex() {
        return this.dataSourceIndex[SOURCE_TYPES.discreteEnvirodata] || []
      },
      currentDiscreteStation() {
        return this.discreteStationsIndex[this.discreteDataSource.SourceId]
      },
      isQaQc() {
        return this.mergeType == ALIAS_TYPES.qaqcAlias.value
      },
      isDepthHeightDatum() {
        return this.mergeType == ALIAS_TYPES.depthHeightAlias.value
      },
    },
    methods: {
      show() {
        this.dialog = true
      },
      close() {
        this.dialog = false
      },
      async submit() {
        this.loading = true
        await this.$refs.form.submit()
        this.loading = false
      },
    },
  }
</script>